import { chakra } from "@chakra-ui/system";
import { memo } from "react";

function LogoBird({
  primary = "#3B82F6",
  secondary = "#4FC06C",
  ...rest
}: any) {
  return (
    <chakra.svg fill="none" {...rest} viewBox="0 0 230 185">
      <path
        fill={secondary}
        d="M117.518 123.905s17.509-17.741 3.144-26.926a7.165 7.165 0 00-.495-.314 42.768 42.768 0 00-3.073-1.517c8.903 3.456 18.615 8.177 24.991 14.033 2.198 9.764 1.459 20.12-3.957 30.683-2.147 1.717-4.637 3.472-7.515 5.261-.389.182-.783.361-1.172.544-9.437 4.416-18.776 9.054-27.975 13.955a430.553 430.553 0 00-15.734 8.784C76.693 173.715 67.98 179.356 60.73 185c-.123-.351 56.789-61.095 56.789-61.095z"
      ></path>
      <path
        fill={primary}
        d="M147.551 129.482c14.8-16.046 1.822-51.509-4.275-65.641 0-.017-.016-.017-.016-.017-.384-.913-1.296-3.174-2.541-5.967 8.47-19.42 27.254-24.305 47.717-8.993 0 0 18.497-9.304 41.551-8.492 0 0-37.059 4.301-47 21.747-9.942 17.462-11.535 41.089-28.008 66.724-2.98 4.636-6.819 7.567-11.074 9.925-.306.172-.626.327-.937.492a40.658 40.658 0 004.583-9.778"
      ></path>
      <path
        fill={secondary}
        d="M128.499 45.247c3.211 2.86 7.982 9.607 10.977 15.742 1.848 3.791 3.219 7.057 3.728 8.204 0 0 .016 0 .016.016 6.931 15.31 22.528 55.937.685 69.559-.302.189-.644.352-.962.532 8.802-13.668 20.673-50.025-57.455-94.324 0 0 80.684 46.648 51.319 97.307-.299.141-.598.276-.899.421-1.084.477-2.167.971-3.251 1.465l-2.055.956c10.022-9.335 12.347-19.756 9.193-28.9v-.017c-3.075-8.922-11.328-16.664-22.703-21.062-6.229-2.788-14.021-4.97-14.021-4.97s-5.83-1.785-8.22-4.398c-2.374-2.597-15.537-24.012-34.122-44.057-9.273-10-42.512-40.048-44.87-41.721.175 0 69.629 6.943 112.64 45.247"
      ></path>
    </chakra.svg>
  );
}

export default memo(LogoBird);
